import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/es/storage'
import usersLogsGroupsSlice from '../reducers/usersLogsGroups.slice'

const persistConfig = {
  key: 'usersLogsGroupsSlice',
  storage,
}

export const persistedUsersLogsGroupsReducer = persistReducer(persistConfig, usersLogsGroupsSlice)